import { create } from "zustand";
import { persist } from "zustand/middleware";

const useStore = create(
  persist(
    (set) => ({
      // Preferencias de usuario (persisten en localStorage)
      user: "",
      language: "es",
      organization: "",
      organizationName: "",
      project: "",
      projectName: "",
      plan: "",
      appMode: "legacy",
      // Modo ERP habilitado para la organización actual (GET /erp/enabled)
      erpEnabled: false,
      // Rol ERP del usuario: kam | bp | comercial | null (v1 sin permisos finos)
      erpRole: null,
      // Módulos ATS y Hunting de la organización actual (GET /organizations/modules,
      // 2026-10-26). null = todavía no se sabe (recién elegida la organización).
      atsEnabled: null,
      huntingEnabled: null,
      setUser: (userData) => set({ user: userData }),
      setLanguage: (lang) => set({ language: lang }),
      // Al cambiar de organización el modo vuelve a Evaluaciones: cada modo
      // (ATS / ERP / Hunting) se habilita por organización y no debe
      // "arrastrarse" a otra (Erwin, 2026-09-30).
      // Los módulos ATS/Hunting también se olvidan: son de cada organización.
      setOrganization: (org) =>
        set((state) => ({
          organization: org,
          ...(state.organization !== org ? { appMode: 'legacy', atsEnabled: null, huntingEnabled: null } : {}),
        })),
      setOrganizationName: (org) => set({ organizationName: org }),
      setProject: (proj) => set({ project: proj }),
      setProjectName: (proj) => set({ projectName: proj }),
      setPlan: (pl) => set({ plan: pl }),
      setAppMode: (mode) => set({ appMode: mode }),
      setErpEnabled: (enabled) => set({ erpEnabled: enabled }),
      setErpRole: (erpRole) => set({ erpRole }),
      setOrganizationModules: ({ ats, hunting }) => set({ atsEnabled: ats, huntingEnabled: hunting }),

      // Token de autenticación (solo en memoria)
      authToken: "",
      setAuthToken: (token) => set({ authToken: token }),
      clearAuthToken: () => set({ authToken: "" }),

      // Función para refrescar el token
      refreshAuthToken: async (user) => {
        if (user) {
          const token = await user.getIdToken(true);
          set({ authToken: token });
          return token;
        }
        return null;
      },

      // Alert
      alertOpen: false,
      alertMessage: "",
      alertSeverity: "info",
      showAlert: (message, severity = "info") =>
        set({
          alertMessage: message,
          alertSeverity: severity,
          alertOpen: true,
        }),
      closeAlert: () => set({ alertOpen: false }),

      resetStore: () => {
        localStorage.removeItem("user-preferences");
        set({
          user: "",
          organization: "",
          organizationName: "",
          project: "",
          projectName: "",
          plan: "",
          authToken: "",
          alertOpen: false,
          alertMessage: "",
          alertSeverity: "info",
          language: "es",
          appMode: "legacy",
          erpEnabled: false,
          erpRole: null,
          atsEnabled: null,
          huntingEnabled: null,
        });
      },
    }),
    {
      name: "user-preferences",
      partialize: (state) => ({
        organization: state.organization,
        organizationName: state.organizationName,
        project: state.project,
        projectName: state.projectName,
        plan: state.plan,
        user: state.user,
        language: state.language,
        appMode: state.appMode,
        erpEnabled: state.erpEnabled,
        erpRole: state.erpRole,
        atsEnabled: state.atsEnabled,
        huntingEnabled: state.huntingEnabled,
      }),
    }
  )
);

export default useStore;